import { useUser } from '@kaiizen/kai-pro-api-react-state';

import { getShortPersonLabel } from '@/Client/Lib';

/**
 * Who made a change, as "First L.". Looked up by id rather than from the org's user list, so an
 * actor from outside the viewer's org is still named; "—" when there is no one to name.
 */
export const ActivityLogTableWho = ({ userId }: { userId?: string }) => {
  const { user } = useUser(userId);
  return <>{getShortPersonLabel(user?.name) ?? '—'}</>;
};
